import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { formatRichText } from '~/ui/utils/rich-text.helper';
import { classMap } from 'lit/directives/class-map.js';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './module-title.styles';

export class ModuleTitle extends DERElement {
    @property({ type: String }) suptitle = '';
    @property({ type: String }) override title = '';
    @property({ type: String }) intro = '';
    @property({ type: Boolean }) inverted = false;

    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    override render() {
        return html`
            <header class="c-module-title">
                ${this.suptitle
                    ? html`<span
                          class=${classMap({
                              'c-module-title__suptitle': true,
                              'c-module-title__suptitle--inverted': !!this.inverted,
                          })}
                          >${this.suptitle}</span
                      >`
                    : ''}
                <div class="c-module-title__wrapper">
                    <h2
                        class=${classMap({
                            'c-module-title__title': true,
                            'c-module-title__title--inverted': !!this.inverted,
                        })}
                    >
                        ${this.title}
                    </h2>
                    ${this.intro
                        ? html`<p
                              class=${classMap({
                                  'c-module-title__text': true,
                                  'c-module-title__text--inverted': !!this.inverted,
                              })}
                          >
                              ${unsafeHTML(formatRichText(this.intro))}
                          </p>`
                        : ''}
                </div>
            </header>
        `;
    }
}
